export enum LabelPositionOpts {
  LEFT = 'left',
  RIGHT = 'right',
}

// for specs; to update if CheckboxProps interface in UiCheckbox.vue updates
export interface CheckboxProps {
  id: string
  modelValue: string[] | boolean // binding value of v-model; checkbox is checked by default if set to true
  label?: string
  ariaLabel?: string
  isDisabled?: boolean
  labelPosition?: LabelPositionOpts
  nativeValue?: string | boolean // boolean if native checkbox value is undefined
}
